import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  getFirestore,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { Project } from "./ProjectsContext";

export const createProject = async (userId: string, data: Project) => {
  const db = getFirestore();
  const projectsRef = collection(db, "users", userId, "projects");

  const project = await addDoc(projectsRef, {
    ...data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return project.id;
};

export const deleteProject = async (userId: string, projectId: string) => {
  const db = getFirestore();

  await deleteDoc(doc(db, "users", userId, "projects", projectId));
};

export const fetchProjects = async (userId: string) => {
  const db = getFirestore();
  const projectsRef = collection(db, "users", userId, "projects");
  const orderedProjectsQuery = query(projectsRef, orderBy("createdAt"));

  const projectDocs = await getDocs(orderedProjectsQuery);
  const projects = projectDocs.docs.map((doc) => ({
    ...(doc.data() as Project),
    id: doc.id,
  }));
  return projects;
};

export const updateProject = async (
  userId: string,
  projectId: string,
  updatedFields: Partial<Project>,
) => {
  const db = getFirestore();
  const projectRef = doc(db, "users", userId, "projects", projectId);

  await updateDoc(projectRef, {
    ...updatedFields,
    updatedAt: serverTimestamp(),
  });
};
